import { LessonOverviewScreen } from '@/screens/lesson-overview-screen/LessonOverviewScreen'

export default function () {
  return <LessonOverviewScreen />
}
